const Footer = () => {

    return (
        <footer>
            <p>Created by Aaron Hoffman and Yemisi Adeleye at <a href="https://junocollege.com/">Juno College</a>.</p>
        </footer>
    )
}

export default Footer;